import {
  LdtStatusFilterValue,
  createOption,
} from '@ldt/features/orders/statuses/workflow_shared';
import { OrderStatus } from 'src/types';
import type { OrderStatusFilterOption } from 'src/types/status_filter';
import {
  capitalizeFirstLetter,
  isCustomerSuccessOrSalesUser,
  isLabTech,
} from 'src/utils';

export function getStatusDisplayName(status: OrderStatus): string {
  switch (status) {
    case OrderStatus.Draft:
      return 'Path Report or TRF Pending';
    case OrderStatus.QualityControlPending:
      return 'Clin Vars Pending - CS';
    case OrderStatus.QualityControlApproved:
      return 'Clin Vars Pending - Tempus';
    case OrderStatus.LabProcessing:
      return 'Image Pending';
    case OrderStatus.AiProcessing:
      return 'AI Processing';
    case OrderStatus.AiError:
      return 'AI Error';
    case OrderStatus.ReportPending:
      return 'Report Pending';
    case OrderStatus.ReportReady:
      return 'Report Ready';
    case OrderStatus.Canceled:
      return 'Canceled';
    default:
      return capitalizeFirstLetter(status);
  }
}

export function getStatusFilterOptions(): Map<string, OrderStatusFilterOption> {
  if (isCustomerSuccessOrSalesUser()) {
    return new Map<string, OrderStatusFilterOption>([
      createOption(LdtStatusFilterValue.ALL_ORDERS, 'All Orders'),
      createOption(
        LdtStatusFilterValue.PATHOLOGY_REPORT_PENDING,
        'Path Report or TRF Pending',
        [OrderStatus.Draft],
      ),
      createOption(
        LdtStatusFilterValue.CLIN_VARS_PENDING_CS,
        'Clin Vars Pending - CS',
        [OrderStatus.QualityControlPending],
      ),
      createOption(
        LdtStatusFilterValue.CLIN_VARS_PENDING_TEMPUS,
        'Clin Vars Pending - Tempus',
        [OrderStatus.QualityControlApproved],
      ),
      createOption(LdtStatusFilterValue.IMAGE_PENDING, 'Image Pending', [
        OrderStatus.LabProcessing,
      ]),
      createOption(LdtStatusFilterValue.AI_PROCESSING, 'AI Processing', [
        OrderStatus.AiProcessing,
      ]),
      createOption(LdtStatusFilterValue.REPORT_PENDING, 'Report Pending', [
        OrderStatus.ReportPending,
      ]),
      createOption(LdtStatusFilterValue.AI_ERROR, 'AI Error', [
        OrderStatus.AiError,
      ]),
      createOption(LdtStatusFilterValue.REPORT_READY, 'Report Ready', [
        OrderStatus.ReportReady,
      ]),
    ]);
  } else if (isLabTech()) {
    return new Map<string, OrderStatusFilterOption>([
      createOption(LdtStatusFilterValue.ALL_ORDERS, 'All Orders'),
      createOption(
        LdtStatusFilterValue.PATHOLOGY_REPORT_PENDING,
        'Path Report or TRF Pending',
        [OrderStatus.Draft],
      ),
      createOption(
        LdtStatusFilterValue.CLIN_VARS_PENDING_TEMPUS,
        'Clin Vars Pending - Tempus',
        [OrderStatus.QualityControlApproved],
      ),
    ]);
  }

  throw new Error('Invalid user role');
}
